// extracted by mini-css-extract-plugin
module.exports = {"container":"Section7_container__Xm_80","content":"Section7_content__bfJ0I","headline":"Section7_headline__aRn_e","subHeadline":"Section7_subHeadline__g2_Fx"};